export default "__VITE_ASSET__7bc46219__"